"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Stack_1 = require("../Stack");
exports.Form = react_1.forwardRef((_a, ref) => {
    var { onSubmit } = _a, rest = __rest(_a, ["onSubmit"]);
    return (jsx_runtime_1.jsx(Stack_1.Stack, Object.assign({ direction: "column", spacing: 3, as: "form", ref: ref, onSubmit: ((e) => {
            e.preventDefault();
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(e);
        }) }, rest), void 0));
});
//# sourceMappingURL=index.js.map